var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#28293D",
    d: "M9.918 4.106c0 2.175-1.773 3.938-3.959 3.938S2.001 6.281 2.001 4.106C2.001 1.93 3.773.167 5.959.167S9.918 1.93 9.918 4.106ZM11.834 12.936c0 2.152-2.612 3.897-5.834 3.897-3.221 0-5.833-1.744-5.833-3.897C.167 10.784 2.779 9.04 6 9.04c3.222 0 5.834 1.745 5.834 3.897ZM10.263 7.023c.547.527 1.29.855 2.112.855a3.034 3.034 0 0 0 3.042-3.026 3.034 3.034 0 0 0-3.042-3.027c-.57 0-1.097.166-1.553.438a5.136 5.136 0 0 1-.56 4.76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#28293D",
    d: "M16.833 11.94c0-1.74-2.238-3.15-5-3.15a7.75 7.75 0 0 0-1.422.131c.135.078.284.142.41.227 1.28.855 2.262 2.17 2.262 3.788 0 .788-.235 1.502-.622 2.128 2.464-.195 4.372-1.517 4.372-3.123Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersSolid);
export default __webpack_public_path__ + "static/media/users-solid.35802d983b7387692b4650cd4077ce7f.svg";
export { ForwardRef as ReactComponent };